/* Custom Gift Corner - light GSAP motion layer (cgc-motion.js) */
(function () {
  'use strict';

  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  var hasGsap = !!(gsap && ST);
  var html = document.documentElement;
  var state = { motion: false, ctx: null, booted: false, headerAbort: null, cartBound: false };
  var START = 'top 88%';
  var refreshTimer = null;

  function canAnimate() { return hasGsap && state.motion; }
  function fire(fn) { if (typeof fn === 'function') fn(); }

  // Elements matching selector, including root itself
  function qsa(root, sel) {
    var list = [];
    if (root && root.nodeType === 1 && root.matches(sel)) list.push(root);
    if (root && root.querySelectorAll) list = list.concat(Array.prototype.slice.call(root.querySelectorAll(sel)));
    return list;
  }

  function refreshSoon() {
    if (!hasGsap) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { ST.refresh(); }, 150);
  }

  function watchImages(el) {
    el.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refreshSoon, { once: true });
    });
  }

  /* 1 + 2: reveal and stagger */
  function initReveal(root) {
    qsa(root, '[data-motion="reveal"]:not([data-motion-ready])').forEach(function (el) {
      el.setAttribute('data-motion-ready', '');
      gsap.from(el, { autoAlpha: 0, y: 18, duration: 0.6, ease: 'power2.out', scrollTrigger: { trigger: el, start: START, once: true } });
      watchImages(el);
    });
    qsa(root, '[data-motion="stagger"]:not([data-motion-ready])').forEach(function (el) {
      el.setAttribute('data-motion-ready', '');
      var items = el.querySelectorAll('[data-motion-item]');
      items = items.length ? Array.prototype.slice.call(items) : Array.prototype.slice.call(el.children);
      if (!items.length) return;
      gsap.from(items, { autoAlpha: 0, y: 18, duration: 0.6, ease: 'power2.out', stagger: 0.06, scrollTrigger: { trigger: el, start: START, once: true } });
      watchImages(el);
    });
  }

  /* 3: hero carousel */
  function initHero(root) {
    qsa(root, '[data-motion="hero"]:not([data-motion-ready])').forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      if (!slides.length) return;
      hero.setAttribute('data-motion-ready', '');
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      var toggle = hero.querySelector('[data-hero-toggle]');
      var label = toggle ? toggle.querySelector('[data-hero-toggle-label]') : null;
      var delay = parseInt(hero.getAttribute('data-hero-delay'), 10) || 6000;
      var ac = new AbortController();
      var opt = { signal: ac.signal };
      var n = slides.length;
      var idx = 0;
      var timer = null;
      var zoom = null;
      var userPaused = !state.motion; // reduced motion: no autoplay
      var hover = false;
      var focus = false;

      function setToggle() {
        if (!toggle) return;
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        if (label) label.textContent = userPaused ? 'Play' : 'Pause';
      }

      function startZoom() {
        if (zoom) zoom.kill();
        zoom = null;
        var img = slides[idx].querySelector('img');
        if (state.motion && img) zoom = gsap.fromTo(img, { scale: 1 }, { scale: 1.04, duration: 8, ease: 'power1.out' });
      }

      function show(i, instant) {
        var old = idx;
        idx = (i + n) % n;
        slides.forEach(function (s, k) {
          var on = k === idx;
          s.classList.toggle('is-active', on);
          if (on) { s.removeAttribute('aria-hidden'); s.inert = false; }
          else { s.setAttribute('aria-hidden', 'true'); s.inert = true; }
        });
        dots.forEach(function (d, k) {
          if (k === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
        if (instant || !state.motion || old === idx) {
          slides.forEach(function (s, k) { gsap.killTweensOf(s); gsap.set(s, { autoAlpha: k === idx ? 1 : 0 }); });
        } else {
          gsap.to(slides[old], { autoAlpha: 0, duration: 0.8, ease: 'power1.inOut', overwrite: 'auto' });
          gsap.to(slides[idx], { autoAlpha: 1, duration: 0.8, ease: 'power1.inOut', overwrite: 'auto' });
        }
        startZoom();
      }

      function schedule() {
        clearTimeout(timer);
        if (userPaused || hover || focus || document.hidden || n < 2) return;
        timer = setTimeout(function () { go(idx + 1); }, delay);
      }

      function go(i) { show(i, false); schedule(); }

      if (prev) prev.addEventListener('click', function () { go(idx - 1); }, opt);
      if (next) next.addEventListener('click', function () { go(idx + 1); }, opt);
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }, opt); });
      if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; setToggle(); schedule(); }, opt);
      hero.addEventListener('mouseenter', function () { hover = true; schedule(); }, opt);
      hero.addEventListener('mouseleave', function () { hover = false; schedule(); }, opt);
      hero.addEventListener('focusin', function () { focus = true; schedule(); }, opt);
      hero.addEventListener('focusout', function (e) {
        if (!hero.contains(e.relatedTarget)) { focus = false; schedule(); }
      }, opt);
      hero.addEventListener('keydown', function (e) {
        var t = e.target;
        if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      }, opt);
      document.addEventListener('visibilitychange', schedule, opt);

      hero._cgcHero = {
        destroy: function () {
          clearTimeout(timer);
          ac.abort();
          if (zoom) zoom.kill();
          hero.removeAttribute('data-motion-ready');
          hero._cgcHero = null;
        }
      };

      setToggle();
      show(0, true);
      schedule();
    });
  }

  function destroyHeroes(root) {
    qsa(root, '[data-motion="hero"]').forEach(function (h) { if (h._cgcHero) h._cgcHero.destroy(); });
  }

  /* 4: compact header */
  function initHeader(root) {
    var header = qsa(root, '[data-cgc-header]:not([data-motion-ready])')[0];
    if (!header) return;
    header.setAttribute('data-motion-ready', '');
    if (state.headerAbort) state.headerAbort.abort();
    var ac = new AbortController();
    state.headerAbort = ac;
    var ann = document.querySelector('[data-cgc-announcement]');
    var compact = false;
    var ticking = false;

    function update() {
      ticking = false;
      var c = (window.scrollY || window.pageYOffset) > 80;
      if (c === compact) return;
      compact = c;
      header.classList.toggle('is-compact', c);
      if (!ann) return;
      gsap.killTweensOf(ann);
      if (c) {
        if (state.motion) {
          gsap.to(ann, { autoAlpha: 0, yPercent: -100, duration: 0.25, ease: 'power2.out', onComplete: function () { ann.style.display = 'none'; } });
        } else {
          gsap.set(ann, { autoAlpha: 0, yPercent: -100 });
          ann.style.display = 'none';
        }
      } else {
        ann.style.display = '';
        if (state.motion) gsap.to(ann, { autoAlpha: 1, yPercent: 0, duration: 0.25, ease: 'power2.out' });
        else gsap.set(ann, { autoAlpha: 1, yPercent: 0 });
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true, signal: ac.signal });
    ac.signal.addEventListener('abort', function () {
      header.classList.remove('is-compact');
      if (ann) { gsap.killTweensOf(ann); ann.style.display = ''; gsap.set(ann, { clearProps: 'opacity,visibility,transform' }); }
    });
    update();
  }

  /* 7: accordion height (listeners check motion at runtime) */
  function initAccordion(root) {
    qsa(root, '[data-accordion]').forEach(function (wrap) {
      wrap.querySelectorAll('details:not([data-motion-ready])').forEach(function (d) {
        d.setAttribute('data-motion-ready', 'acc');
        var summary = d.querySelector('summary');
        var closing = false;
        d.addEventListener('toggle', function () {
          var body = d.querySelector('.cgc-acc__body');
          if (!d.open || !body || !canAnimate() || closing) return;
          gsap.killTweensOf(body);
          gsap.fromTo(body, { height: 0, overflow: 'hidden' }, {
            height: body.scrollHeight, duration: 0.3, ease: 'power2.inOut',
            onComplete: function () { gsap.set(body, { clearProps: 'height,overflow' }); refreshSoon(); }
          });
        });
        if (summary) summary.addEventListener('click', function (e) {
          var body = d.querySelector('.cgc-acc__body');
          if (!d.open || !body || !canAnimate()) return;
          e.preventDefault();
          closing = true;
          gsap.killTweensOf(body);
          gsap.fromTo(body, { height: body.offsetHeight, overflow: 'hidden' }, {
            height: 0, duration: 0.3, ease: 'power2.inOut',
            onComplete: function () {
              d.open = false;
              gsap.set(body, { clearProps: 'height,overflow' });
              closing = false;
              refreshSoon();
            }
          });
        });
      });
    });
  }

  /* 8: cart count pulse */
  function bindCart() {
    if (state.cartBound) return;
    state.cartBound = true;
    document.addEventListener('cgc:added', function () {
      if (!canAnimate()) return;
      document.querySelectorAll('[data-cgc-cart-count]').forEach(function (el) {
        gsap.killTweensOf(el);
        gsap.timeline()
          .to(el, { scale: 1.25, duration: 0.175, ease: 'power2.out' })
          .to(el, { scale: 1, duration: 0.175, ease: 'power2.in' });
      });
    });
  }

  function run(root) {
    if (state.motion) initReveal(root);
    initHero(root);
    initHeader(root);
    initAccordion(root);
  }

  function teardown() {
    destroyHeroes(document);
    if (state.headerAbort) { state.headerAbort.abort(); state.headerAbort = null; }
    document.querySelectorAll('[data-motion-ready]').forEach(function (el) {
      if (el.getAttribute('data-motion-ready') !== 'acc') el.removeAttribute('data-motion-ready');
    });
  }

  function boot() {
    if (state.booted || !hasGsap) return;
    state.booted = true;
    gsap.registerPlugin(ST);
    bindCart();
    var mm = gsap.matchMedia();
    mm.add({ ok: '(prefers-reduced-motion: no-preference)', reduce: '(prefers-reduced-motion: reduce)' }, function (ctx) {
      state.motion = !!ctx.conditions.ok;
      state.ctx = ctx;
      run(document);
      return function () { teardown(); state.ctx = null; };
    });
  }

  function init(root) {
    if (!hasGsap) return;
    root = root || document;
    if (!state.booted) { boot(); if (root === document) return; }
    if (state.ctx) state.ctx.add(function () { run(root); });
    else run(root);
  }

  /* 5: mega panels */
  function openPanel(el) {
    if (!el) return;
    if (hasGsap) gsap.killTweensOf(el);
    el.hidden = false;
    if (!canAnimate()) {
      if (hasGsap) gsap.set(el, { clearProps: 'opacity,visibility,transform' });
      return;
    }
    var cols = el.querySelectorAll('[data-mega-col]');
    var tl = gsap.timeline();
    tl.fromTo(el, { autoAlpha: 0, y: 8 }, { autoAlpha: 1, y: 0, duration: 0.18, ease: 'power2.out' });
    if (cols.length) {
      gsap.killTweensOf(cols);
      tl.fromTo(cols, { autoAlpha: 0, y: 6 }, { autoAlpha: 1, y: 0, duration: 0.2, stagger: 0.03, ease: 'power2.out' }, '<0.04');
    }
    return tl;
  }

  function closePanel(el, done) {
    if (!el) { fire(done); return; }
    if (hasGsap) gsap.killTweensOf(el);
    if (!canAnimate()) {
      el.hidden = true;
      if (hasGsap) gsap.set(el, { clearProps: 'opacity,visibility,transform' });
      fire(done);
      return;
    }
    gsap.to(el, {
      autoAlpha: 0, y: 6, duration: 0.14, ease: 'power1.in',
      onComplete: function () {
        el.hidden = true;
        gsap.set(el, { clearProps: 'opacity,visibility,transform' });
        fire(done);
      }
    });
  }

  /* 6: drawers */
  function openDrawer(el, backdrop) {
    if (!el) return;
    html.classList.add('cgc-scroll-lock');
    el.hidden = false;
    if (backdrop) backdrop.hidden = false;
    if (!canAnimate()) return;
    gsap.killTweensOf(el);
    gsap.fromTo(el, { xPercent: 100 }, { xPercent: 0, duration: 0.35, ease: 'power3.out' });
    if (backdrop) {
      gsap.killTweensOf(backdrop);
      gsap.fromTo(backdrop, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.35, ease: 'power2.out' });
    }
  }

  function closeDrawer(el, backdrop, done) {
    var targets = [el, backdrop].filter(Boolean);
    function finish() {
      targets.forEach(function (t) { t.hidden = true; });
      if (hasGsap && targets.length) gsap.set(targets, { clearProps: 'opacity,visibility,transform' });
      html.classList.remove('cgc-scroll-lock');
      fire(done);
    }
    if (hasGsap && targets.length) gsap.killTweensOf(targets);
    if (!canAnimate() || !el) { finish(); return; }
    gsap.to(el, { xPercent: 100, duration: 0.28, ease: 'power3.in', onComplete: finish });
    if (backdrop) gsap.to(backdrop, { autoAlpha: 0, duration: 0.28, ease: 'power2.in' });
  }

  window.CGCMotion = {
    init: init,
    openPanel: openPanel,
    closePanel: closePanel,
    openDrawer: openDrawer,
    closeDrawer: closeDrawer
  };

  if (!hasGsap) return; // everything stays visible, API works instantly

  /* 9: lifecycle */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  window.addEventListener('load', function () { ST.refresh(); });

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    refreshSoon();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sec = e.target;
    destroyHeroes(sec);
    if (state.headerAbort && sec.querySelector && sec.querySelector('[data-cgc-header]')) {
      state.headerAbort.abort();
      state.headerAbort = null;
    }
    ST.getAll().forEach(function (st) {
      if (st.trigger && sec.contains(st.trigger)) st.kill();
    });
  });
})();
